import {useCallback, useContext} from 'react';

import {useTranslation} from 'react-i18next';
import {useLocation, useNavigate, useParams} from 'react-router-dom';

import {Box} from '@mui/material';

import {ModulePageHeader} from '../../../../components/ModulePageHeader/ModulePageHeader';
import {CompanyContext} from '../../../../contexts/CompanyContext/CompanyContext';
import {WorkforceProfileDetailView} from '../../../../features/company/workforce/components/WorkforceProfileDetail/WorkforceProfileDetailView';
import {AppConfig} from '../../../../lib/AppConfig';
import {ModuleTypes} from '../../../../types/CompanyProductConfiguration/CompanyModule';
import {isCompanyModuleActive} from '../../../../utils/companyModuleUtils/isCompanyModuleActive';

export const WorkforceProfileDetailPage = () => {
  const {id: profileId = ''} = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const {company, productConfiguration} = useContext(CompanyContext);
  const {t} = useTranslation('translation', {keyPrefix: 'workforceProfilesPage'});

  const companyId = company.data?.resourceId ?? '';
  const isWorkforceModuleActive = isCompanyModuleActive(
    ModuleTypes.WorkforceModule,
    productConfiguration.data?.companyModules
  );

  const handleBack = useCallback(() => {
    navigate(`${AppConfig.COMPANY_WORKFORCE_ANALYSIS_PROFILES_PATH}${location.search}`);
  }, [location.search, navigate]);

  if (!isWorkforceModuleActive) {
    return null;
  }

  return (
    <Box sx={{maxWidth: 1120, mx: 'auto', width: '100%'}}>
      <ModulePageHeader moduleName={t('breadcrumb')} title={t('title')} />
      <WorkforceProfileDetailView companyId={companyId} profileId={profileId} onBack={handleBack} />
    </Box>
  );
};
